export enum ServiceExecutionStatus {
  WaitingParts = "AGUARDANDO_PECA",
  InProgress = "EM_EXECUCAO",
  Finished = "FINALIZADO",
  WaitingTrack = "AGUARDANDO_PISTA",
}

